export const apiUrl = process.env.API_URL || "https://movie-api-8cvs.onrender.com";